import gql from 'graphql-tag'

export const PRODUCT_DELETE_MUTATION = gql`
    mutation productDelete(
        $id: ID!
    ) {
        productDelete(
            id: $id
        ) {
            status
        }
    }
`
